import React from 'react'
import { ArrowLeft } from 'react-feather'

import { SlideUpPopover } from '@frame/ui-components/slide-up-popover'
import { Button } from '@frame/ui-primitives/button'
import { H3 } from '@frame/ui-primitives/h3'
import { P } from '@frame/ui-primitives/p'

import { useFileUploadContext } from '@documents/contexts/file-upload-context'
import { DataAttribute } from '@frame/types'

type Props = {
  isOpen: boolean
  confirmText: string
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}

export function ConfirmPopover({ isOpen, confirmText, isLoading, onClose, onConfirm }: Props) {
  const {
    dropzone: { open },
  } = useFileUploadContext()

  function handleClickUploadMore() {
    onClose()
    setTimeout(() => open(), 150)
  }

  function handleHide() {
    if (!isLoading) {
      onClose()
    }
  }

  return (
    <SlideUpPopover show={isOpen} hide={handleHide}>
      <div className="mb-4 flex items-center space-x-2">
        <Button
          aria-label="Back"
          onClick={onClose}
          disabled={isLoading}
          Icon={ArrowLeft}
          border={false}
          intent="secondary"
        />
        <H3>{confirmText}?</H3>
      </div>
      <div className="flex flex-col gap-5">
        <P>You cannot upload additional documents after submission.</P>
        <div className="flex flex-col gap-3">
          <Button data-cy={DataAttribute.DOCUMENTS_CONFIRM_SUBMISSION} onClick={onConfirm} disabled={isLoading}>
            {confirmText}
          </Button>
          <Button intent="secondary" onClick={handleClickUploadMore} disabled={isLoading}>
            Upload more documents
          </Button>
        </div>
      </div>
    </SlideUpPopover>
  )
}
